<template>
  <svg
    v-if="iconLib === 'fluent'"
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-for="(source, index) in pathSource"
      :key="source"
      :d="source"
      :stroke="strokeSource[index]"
      :fill="strokeSource[index] ? '' : fillSource[index] || 'currentColor'"
      :stroke-linecap="strokeLinecap"
      :stroke-linejoin="strokeLinejoin"
      :stroke-width="!isInSidebar ? '1.66667' : '1'"
    />
  </svg>
  <svg
    v-else
    :width="size"
    :height="size"
    fill="none"
    :viewBox="viewBox"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g v-for="(pathData, index) in pathSource" :key="index">
      <path :key="pathData" :d="pathData" stroke="currentColor" />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    size: {
      type: [String, Number],
      default: '20',
    },
    type: {
      type: String,
      default: 'outline',
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
    iconLib: {
      type: String,
      default: 'fluent',
    },
    isInSidebar: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    pathSource() {
      const pathKey = `${this.icon}-${this.type}`;
      const path = this.icons[pathKey];

      if (path && path.constructor === Object) {
        return path.paths;
      }

      if (path && path.constructor === Array) {
        return path;
      }
      if (path) {
        return [path];
      }
      return [];
    },
    fillSource() {
      const pathKey = `${this.icon}-${this.type}`;
      const path = this.icons[pathKey];

      if (path && path.constructor === Object) {
        return path.fills;
      }

      return [];
    },
    strokeSource() {
      const pathKey = `${this.icon}-${this.type}`;
      const path = this.icons[pathKey];

      if (path && path.constructor === Object) {
        return path.stroke;
      }

      return [];
    },
    strokeLinecap() {
      const pathKey = `${this.icon}-${this.type}`;
      const path = this.icons[pathKey];

      if (path && path.constructor === Object) {
        return path.strokelinecap || '';
      }
      return '';
    },
    strokeLinejoin() {
      const pathKey = `${this.icon}-${this.type}`;
      const path = this.icons[pathKey];

      if (path && path.constructor === Object) {
        return path.strokelinejoin || '';
      }
      return '';
    },
  },
};
</script>
